/* global gtag */
import * as React from "react";
import { useState, useRef, useEffect, lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkExisting,
  setActionType,
  setGeneratedNeedId,
  setIsChatModalOpen,
  setIsZoomStarted,
  setLink,
  setShowCallDialog,
  setInquiryFullOpen,
} from "../../../../redux/slices/SearchBarSlice";
import {
  resetInquiryState,
  SendInquiry,
  setEnquiryStep,
  setDescription,
  setServiceId,
} from "../../../../redux/slices/InquirySlice";
import {
  setDropdownOpen,
  setIsModalOpen,
} from "../../../../redux/slices/bwvSlice";
import { userAction } from "../../../../redux/slices/userSlice";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { countryCodes } from "../../../CountryCodes";
import { toast } from "react-toastify";
import { getAllMessages, sendMessage } from "../../Data";
import { useSocket } from "../../../../contexts/SocketContext";
import axiosClient from "../../../../axios-client";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import AutoNeedForm from "./AutoNeedForm";
import { FaWindowClose } from "react-icons/fa";

// Lazy-load utilities
const loadUtilities = async () => {
  const { default: axiosClient } = await import("../../../../axios-client");
  const {
    makeCall,
    postRequest,
    sendMsgMail,
    virtualTourClick,
    postOtherVendors,
  } = await import("../../Data");
  const { GetZoomLink } = await import("../../Data2");
  return {
    axiosClient,
    makeCall,
    postRequest,
    postOtherVendors,
    sendMsgMail,
    virtualTourClick,
    GetZoomLink,
    toast,
  };
};

// Debounce utility
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const AutoNeedModal = () => {
  const { selectedConvo } = useSelector((state) => state.messages);
  const islogin = useSelector((state) => state.user.isLogin);
  const userData = useSelector(
    (state) => state.user.userDetails.profileDetails
  );
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const {
    inquiryFullOpen,
    sampleAd,
    actionType,
    checkExistingError,
    checkExistingStatus,
    vTName,
    vTNumber,
    answers,
  } = useSelector((state) => state.searchBar);
  const { sendNewMessage } = useSocket();
  const { dropdownOpen } = useSelector((state) => state.bwvData);
  const { searchQuery } = useSelector((state) => state.lcAds);
  const dispatch = useDispatch();
  // const formData = useSelector((state) => state.requestForm);
  const formData = useSelector((state) => state.inquiry);
  const { otherVendors } = useSelector((state) => state.requestForm);
  const [isLoading, setIsLoading] = useState(false);
  // const [descriptionError, setDescriptionError] = useState(false);
  const [eventDetailsError, setEventDetailsError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [secondaryPhoneError, setSecondaryPhoneError] = useState(false);
  const [zipcodeError, setZipcodeError] = useState(false);
  const [countryCodeError, setCountryCodeError] = useState(false);
  const [mandatoryQuestionsError, setMandatoryQuestionsError] = useState(false);
  const [otherVendorsError, setOtherVendorsError] = useState(false);
  const { bwvSearchQuery } = useSelector((state) => state.bwvData);
  const isProd = process.env.REACT_APP_PRODUCTION === "true";
  const firstInputRef = useRef(null);
  const [selectedCountry, setSelectedCountry] = useState("+1");
  const isAdmin = user && user.Role === "admin";
  const isVendor = user?.Role === "provider";
  const handleClose = () => {
    dispatch(setInquiryFullOpen(false));
    dispatch(resetInquiryState());
    dispatch(setDescription(""));
    // setDescriptionError(false);
    setEventDetailsError(false);
    setEmailError(false);
    setPhoneError(false);
    setSecondaryPhoneError(false);
    setZipcodeError(false);
    setCountryCodeError(false);
    setMandatoryQuestionsError(false);
    setOtherVendorsError(false);
    dispatch(setEnquiryStep(1));
    dispatch(setShowCallDialog(false));
  };
  const validateEventDetails = (eventDetails) => {
    if (!eventDetails) return false;
    try {
      const event = JSON.parse(eventDetails)[0];
      return (
        event.eventDate &&
        event.eventTime &&
        event.eventType &&
        event.eventLocation &&
        event.totalGuestCount &&
        event.eventDate.trim() !== "" &&
        event.eventTime.trim() !== "" &&
        event.eventType.trim() !== "" &&
        event.eventLocation.trim() !== "" &&
        event.totalGuestCount.trim() !== ""
      );
    } catch (error) {
      console.error("Error parsing eventDetails:", error);
      return false;
    }
  };

  const validateMandatoryQuestions = () => {
    if (formData.engagedCouple !== 1 || !sampleAd?.Questions) return true;
    try {
      const parsedQuestions = JSON.parse(sampleAd.Questions);
      return parsedQuestions.every((question) => {
        if (!question.mandatory) return true;
        const answer = answers[question.label];
        if (question.type === "text" && (!answer || answer.trim() === "")) {
          return false;
        }
        if (question.type === "options" && (!answer || answer === "")) {
          return false;
        }
        if (question.type === "check" && answer !== true) {
          return false;
        }
        return true;
      });
    } catch (error) {
      console.error(
        "Failed to parse sampleAd.Questions for validation:",
        error
      );
      return true;
    }
  };

  const validateForm = () => {
    let isValid = true;

    if (!islogin && !formData.Email) {
      setEmailError(true);
      toast.error("Email is required");
      isValid = false;
    }
    if (!formData.Zipcode || !/^\d{5}$/.test(formData.Zipcode)) {
      setZipcodeError(true);
      toast.error("Valid 5-digit zipcode is required");
      isValid = false;
    }
    if (!formData.Phone || formData.Phone.length !== 10) {
      setPhoneError(true);
      toast.error("Valid 10-digit phone number is required");
      isValid = false;
    }
    if (
      formData.alternativePhoneOne &&
      formData.alternativePhoneOne.length !== 10
    ) {
      setSecondaryPhoneError(true);
      toast.error("Valid 10-digit secondary phone number is required");
      isValid = false;
    }
    if (formData.alternativePhoneOne === formData.Phone) {
      setSecondaryPhoneError(true);
      toast.error(
        "Secondary phone number should be different from primary phone number"
      );
      isValid = false;
    }
    if (!selectedCountry) {
      setCountryCodeError(true);
      toast.error("Please select a country code");
      isValid = false;
    }
    // if (!formData?.Description || formData?.Description.trim() === "") {
    //   setDescriptionError(true);
    //   toast.error("Description is required");
    //   isValid = false;
    // }
    if (formData.engagedCouple === 1) {
      const isEventDetailsValid = validateEventDetails(formData.eventDetails);
      if (!isEventDetailsValid) {
        setEventDetailsError(true);
        toast.error("Please fill in all event details");
        isValid = false;
      }
      const isQuestionsValid = validateMandatoryQuestions();
      if (islogin && !isQuestionsValid) {
        setMandatoryQuestionsError(true);
        toast.error("Please answer all mandatory questions");
        isValid = false;
      }
    }
    if (formData.engagedCouple === 1 && formData.otherVendors.length > 0) {
      if (!formData.noOtherVendors) {
        if (formData.otherVendors.length === 0) {
          setOtherVendorsError(true);
          toast.error(
            "Please select at least one vendor or check 'I don't need other vendors.'"
          );
          isValid = false;
        }
      }
    }
    return isValid;
  };

  useEffect(() => {
    dispatch(setServiceId(sampleAd?.Id || sampleAd?.id || sampleAd?.post_id));
    if (inquiryFullOpen && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [inquiryFullOpen, sampleAd]);

  const handleBackdropClick = (event) => {
    event.stopPropagation();
  };

  useEffect(() => {
    if (checkExistingStatus === "failed" && checkExistingError) {
      toast.error(checkExistingError);
    }
  }, [checkExistingStatus, checkExistingError]);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  const handleStartZoomCall = async () => {
    const { toast, makeCall, GetZoomLink, sendMsgMail, virtualTourClick } =
      await loadUtilities();
    if (!islogin && !vTName) {
      toast.error("Please Enter Email");
      return;
    }
    if (!islogin && !vTNumber) {
      toast.error("Please Enter Phone Number");
      return;
    }
    const serviceInfo = JSON.parse(sampleAd?.additionalPeople || "[]");
    const newPerson1 = {
      email: !islogin ? vTName : user?.Email,
      phoneNumber: !islogin ? vTNumber : user?.Phone,
      countryCode: !islogin ? selectedCountry : user?.CountryCode,
    };
    let newPerson2;
    let newPerson3;
    if (sampleAd.profilePhone === sampleAd.Phone) {
      newPerson2 = {
        email: sampleAd?.Email,
        phoneNumber: sampleAd?.profilePhone,
        countryCode: sampleAd?.countryCode,
      };
    } else {
      newPerson2 = {
        email: sampleAd?.Email,
        phoneNumber: sampleAd?.profilePhone,
        countryCode: sampleAd?.countryCode,
      };
      newPerson3 = {
        email: sampleAd?.Email,
        phoneNumber: sampleAd?.Phone,
        countryCode: sampleAd?.countryCode,
      };
    }
    serviceInfo.unshift(newPerson1);
    serviceInfo.push(newPerson2);
    if (newPerson3) serviceInfo.push(newPerson3);
    const stringifiedAdditionalPeople = JSON.stringify(serviceInfo);
    let formData = {
      email: !islogin ? vTName : user?.Email,
      phoneNumber: !islogin ? vTNumber : user?.Phone,
      countryCode: !islogin ? selectedCountry : user?.CountryCode,
      phoneDetails: stringifiedAdditionalPeople,
      similarLocalVendor: sampleAd?.similarLocalVendor,
      customerName: `${user?.FirstName} ${user?.LastName}`,
      serviceId: sampleAd?.Id,
      customerId: user?.UserID,
    };
    const response = await makeCall(formData);
    toast.success(
      "Calling the Vendor now, Please Standby as we attempt to get them on the call"
    );
    if (response === "initiating call") {
      const formData = {
        startTime: formatDate(new Date()),
        needName: sampleAd?.listName,
      };
      const linkResponse = await GetZoomLink(formData, sampleAd?.Id);
      dispatch(setLink(linkResponse.join_url));
      let formData1 = {
        zoomlink: linkResponse.join_url,
        phoneDetails: stringifiedAdditionalPeople,
        customerId: user?.UserID,
        ownerId: parseInt(sampleAd?.createdBy),
        Type: "details",
        postId: sampleAd?.Id,
        postName: sampleAd?.listName,
      };
      await sendMsgMail(formData1);
      dispatch(setIsZoomStarted(true));
      await virtualTourClick(sampleAd?.Id);
    } else {
      throw new Error("Response from makeCall was invalid");
    }
  };
  const MessageSend = async (
    parent,
    userId,
    fullName,
    createdEmail,
    userRole
  ) => {
    const description =
      !sampleAd?.Questions &&
      Object.keys(answers || {}).length === 0 &&
      (!formData?.eventDetails || formData?.engagedCouple !== 1)
        ? formData?.Description || ""
        : (formData?.Description || "") +
          (sampleAd?.Questions && Object.keys(answers || {}).length > 0
            ? "<br/>" +
              Object.entries(answers)
                .map(([label, answer], index) => {
                  try {
                    const parsedQuestions = JSON.parse(sampleAd.Questions);
                    const question = parsedQuestions.find(
                      (q) => q.label === label
                    );
                    if (!question) return "";
                    return `${index + 1}. <b>${label}</b><br/>${answer}<br/>`;
                  } catch (error) {
                    console.error("Failed to parse sampleAd.Questions:", error);
                    return "";
                  }
                })
                .filter(Boolean)
                .join("")
            : "") +
          (formData?.engagedCouple === 1 && formData?.eventDetails
            ? "<br/><b>Event Details:</b><br/>" +
              (Array.isArray(JSON.parse(formData.eventDetails || "[]")) &&
              JSON.parse(formData.eventDetails || "[]").length > 0
                ? JSON.parse(formData.eventDetails)
                    .map((event, index) => {
                      return (
                        `${index + 1}. ` +
                        `<b>Event Date:</b> ${new Date(
                          event.eventDate
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}<br/>` +
                        `<b>Event Time:</b> ${event.eventTime}<br/>` +
                        `<b>Event Type:</b> ${event.eventType}<br/>` +
                        `<b>Event Location:</b> ${event.eventLocation}<br/>` +
                        `<b>Total Guest Count:</b> ${event.totalGuestCount}<br/>`
                      );
                    })
                    .join("<br/>")
                : "")
            : "") +
          (otherVendors.length > 0
            ? "<br/><b>Other Vendors Needed:</b><br/>" +
              otherVendors
                .map((vendor, index) => `${index + 1}. ${vendor}<br/>`)
                .join("")
            : formData.noOtherVendors
            ? "<br/><b>Other Vendors Needed:</b> None<br/>"
            : "");
    const messageForm = {
      customerId: sampleAd?.createdBy || "0",
      postId: sampleAd?.Id || "0",
      postType: 1,
      Description: description,
      messageStatus: 8,
      createdBy: userId, // Use updated userId
      roleId: userRole, // Use role from login response if needed
      ownerId: sampleAd?.createdBy || "0",
      userName: fullName, // Use first name from fullName
      Email: createdEmail,
      serviceNeed: formData?.engagedCouple === 1 ? "service" : "need",
      parentId: !selectedConvo
        ? parent
          ? parent.Id
          : 0
        : selectedConvo.parentId === 0
        ? selectedConvo.Id
        : selectedConvo.parentId ?? 0,
      //   parentId:
      //     selectedConvo?.parentId === 0
      //       ? selectedConvo?.Id ?? 0
      //       : selectedConvo?.parentId ?? 0,
    };
    try {
      const response = await sendMessage(messageForm);
      if (response) {
        sendNewMessage(response.Data);
      }
    } catch (error) {
      console.error("Failed to send message:", error);
      throw error;
    }
  };

  const reset = () => {
    dispatch(setDescription(""));
    dispatch(resetInquiryState());
    // setDescriptionError(false);
    setEventDetailsError(false);
    setEmailError(false);
    setPhoneError(false);
    setSecondaryPhoneError(false);
    setZipcodeError(false);
    setCountryCodeError(false);
    setMandatoryQuestionsError(false);
    setOtherVendorsError(false);
    dispatch(setActionType(null));
  };

  const proceedResults = async () => {
    const { toast } = await loadUtilities();
    if (!validateForm()) return;
    dispatch(setInquiryFullOpen(false));
    // Initialize userId and userData for logged-in or newly logged-in users
    let userId = user?.UserID || null;
    let fullName = islogin
      ? `${user?.FirstName} ${user?.LastName || ""}`
      : formData?.Email.split("@")[0].trim();
    let createdEmail = user?.Email || formData?.Email;
    let phone = user?.Phone || formData.Phone || null;
    let countryCode = islogin ? user?.CountryCode : selectedCountry;
    let userRole = islogin ? user?.RoleId : 2;
    const actionRequired = async () => {
      if (actionType === "FROMLINK") {
        // handlenavFromLink();
      } else if (actionType === "CALL") {
        dispatch(setShowCallDialog(true));
      } else if (actionType === "TEXT") {
        dispatch(setIsChatModalOpen(true));
      } else if (actionType === "VISIT") {
        window.open(sampleAd.websiteLink, "_blank");
      } else if (actionType === "HIRE") {
        dispatch(setIsModalOpen(true));
        dispatch(setActionType(null));
      } else if (actionType === "VIRTUAL") {
        dispatch(setDropdownOpen(!dropdownOpen));
      } else if (actionType === "VIRTUAL_POP" || actionType === "VIDEO") {
        if (islogin || userId) {
          await handleStartZoomCall();
        }
      }
    };
    let needExists = false;
    if (islogin || userId) {
      const checkForm = {
        Title:
          sampleAd?.Title ||
          sampleAd?.listName ||
          sampleAd?.image_title ||
          bwvSearchQuery + " (Auto Generated)",
        userId: userId,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      needExists = result.data;
    }
    if (needExists) {
      if (actionType === "FROMLINK") {
        removeFbclidFromUrl();
      }
      dispatch(setGeneratedNeedId(sampleAd?.Id));
      dispatch(setInquiryFullOpen(false));
      reset();
      removeFbclidFromUrl();
      return;
    }
    if (isLoading) return;
    setIsLoading(true);
    try {
      const params = {
        ...formData,
        countryCode: selectedCountry,
        Title:
          (sampleAd?.Title ||
            sampleAd?.listName ||
            sampleAd?.image_title ||
            bwvSearchQuery ||
            "") + " (Auto Generated)",
        categoryId: sampleAd?.categoryId || null,
        subCategoryId: sampleAd?.subCategoryId || null,
        itemId: sampleAd?.itemId || null,
        needType: sampleAd ? 1 : null,
        createdBy: user?.UserID || null,
        createdEmail: user?.Email || formData?.Email,
        FullName: user?.FirstName
          ? `${user?.FirstName} ${user?.LastName || ""}`
          : formData?.Email.split("@")[0].trim(),
        enquiryStep: 10,
        // pass serviceId in string
        serviceId: formData.serviceId && String(formData.serviceId),
        vendorId: Number(sampleAd?.createdBy) || 0,
      };
      await dispatch(SendInquiry(params)).unwrap();
      actionRequired();
      toast.success(
        `Inquiry sent successfully for ${
          sampleAd?.Title || sampleAd?.listName || ""
        }`
      );
      if (isProd && window.dataLayer) {
        window.dataLayer.push({
          event: "inquiry_sent",
          method: "inquiry_submission",
          ad_id: sampleAd?.id || sampleAd?.Id,
        });
      }
      if (sampleAd?.createdBy) {
        const req = {
          customerId: +sampleAd?.createdBy,
          needId: sampleAd?.Id || sampleAd?.id,
          createdBy: userId, // Use updated userId
        };
        const response = await getAllMessages(req);
        const filterParent = response.filter((msg) => msg.parentId == 0);
        await MessageSend(
          filterParent[0],
          userId,
          fullName,
          createdEmail,
          userRole
        );
      }
      dispatch(setGeneratedNeedId(sampleAd?.Id));
      dispatch(setInquiryFullOpen(false));
      reset();
      removeFbclidFromUrl();
    } catch (error) {
      console.error("Post request error:", error);
      reset();
      removeFbclidFromUrl();
    } finally {
      setIsLoading(false);
    }
  };

  if (isAdmin || isVendor) return null;
  const removeFbclidFromUrl = () => {
    const url = new URL(window.location.href);
    if (url.searchParams.has("fbclid")) {
      url.searchParams.delete("fbclid");
      window.history.replaceState({}, document.title, url.toString());
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={inquiryFullOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{
          style: {
            maxWidth: `${formData.engagedCouple === 1 ? "1000px" : "600px"}`,
            zIndex: 1085,
          },
        }}
        sx={{ zIndex: 1085 }}
        BackdropProps={{
          onClick: handleBackdropClick,
          style: { zIndex: 1085 },
        }}
      >
        <Button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 1,
          }}
          aria-label="close"
        >
          <FaWindowClose />
        </Button>
        <DialogTitle id="alert-dialog-title">
          Send your inquiry to{" "}
          {sampleAd?.listName || sampleAd?.Title || "vendor"}
        </DialogTitle>
        <DialogContent>
          <AutoNeedForm
            islogin={islogin}
            dispatch={dispatch}
            firstInputRef={firstInputRef}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
            emailError={emailError}
            setEmailError={setEmailError}
            zipcodeError={zipcodeError}
            setZipcodeError={setZipcodeError}
            phoneError={phoneError}
            setPhoneError={setPhoneError}
            secondaryPhoneError={secondaryPhoneError}
            setSecondaryPhoneError={setSecondaryPhoneError}
            countryCodeError={countryCodeError}
            setCountryCodeError={setCountryCodeError}
            // descriptionError={descriptionError}
            // setDescriptionError={setDescriptionError}
            mandatoryQuestionsError={mandatoryQuestionsError}
            setMandatoryQuestionsError={setMandatoryQuestionsError}
            eventDetailsError={eventDetailsError}
            setEventDetailsError={setEventDetailsError}
            otherVendorsError={otherVendorsError}
            setOtherVendorsError={setOtherVendorsError}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={proceedResults} autoFocus disabled={isLoading}>
            {isLoading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Send Inquiry and Proceed"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default AutoNeedModal;
